import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import EditVacationBeingHere from "./EditVacationBeingHere";
import CreateVacationBeingHere from "./CreateVacationBeingHere";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  deleteVacationBeingHere,
  getAllVacationBeingHere,
} from "../../api/VacationBeingHere";
import "../../vendor/css/viewvacationbeinghere.css";

const ViewVacationBeingHere = () => {
  const [vacationBeingHereList, setVacationBeingHereList] = useState([]);
  const [selectedVacationBeingHere, setSelectedVacationBeingHere] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  useEffect(() => {
    const getVacationBeingHereList = async () => {
      try {
        const response = await getAllVacationBeingHere();
        const vacations = Array.isArray(response) ? response : (response?.vacationBeingHere || []);
        setVacationBeingHereList(vacations);
      } catch (error) {
        console.error("Error fetching vacation being here:", error);
        Swal.fire("Error", "Failed to load vacation being here", "error");
      } finally {
        setLoading(false);
      }
    };
    getVacationBeingHereList();
    const interval = setInterval(getVacationBeingHereList, 30000); // Refresh every 30 seconds
    return () => clearInterval(interval);
  }, []);

  // create and edit model state defind here
  const [
    createVacationBeingHereModelShow,
    setCreateVacationBeingHereModelShow,
  ] = useState(false);
  const handleCreateModalClose = () =>
    setCreateVacationBeingHereModelShow(false);
  const handleCreateModalShow = () => setCreateVacationBeingHereModelShow(true);
  const [editVacationBeingHereModelShow, setEditVacationBeingHereModelShow] =
    useState(false);
  const handleEditModalClose = () => setEditVacationBeingHereModelShow(false);
  const handleEditModalShow = () => setEditVacationBeingHereModelShow(true);

  // Filter vacations based on search term
  const filteredVacations = (vacationBeingHereList || []).filter(vacation =>
    vacation.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredVacations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredVacations.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleDeleteVacationBeingHere = (vacationBeingHereToDelete) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteVacationBeingHere(vacationBeingHereToDelete)
          .then((res) => {
            if (res.status === 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              setVacationBeingHereList((prev) =>
                prev.filter(
                  (item) => item._id !== vacationBeingHereToDelete._id
                )
              );
            }
          })
          .catch((err) => {
            console.error("Delete failed:", err);
            Swal.fire("Error", "Failed to delete vacation being here", "error");
          });
      }
    });
  };

  if (loading) {
    return (
      <div className="view-vacations">
        <div className="vacations-header">
          <h1>Vacation Being Here Management</h1>
          <p>Manage and view all vacation being here entries</p>
        </div>
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading vacation being here...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="view-vacations">
      <div className="vacations-header">
        <h1 style={{ fontFamily: 'serif' }}>Vacation Being Here Management</h1>
        <p style={{ fontFamily: 'serif' }}>Manage and view all vacation being here entries</p>
      </div>

      <div className="vacations-stats">
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-map"></i>
          </div>
          <div className="stat-content">
            <h3>{vacationBeingHereList.length}</h3>
            <p>Total Vacations</p>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">
            <i className="bx bx-search"></i>
          </div>
          <div className="stat-content">
            <h3>{filteredVacations.length}</h3>
            <p>Filtered Results</p>
          </div>
        </div>
      </div>

      <div className="vacations-controls">
        <div className="search-container">
          <i className="bx bx-search search-icon"></i>
          <input
            type="text"
            placeholder="Search by vacation name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>
        <button
          className="btn btn-primary add-vacation-btn"
          onClick={handleCreateModalShow}
        >
          <i className="bx bx-plus"></i>
          Add Vacation
        </button>
      </div>

      <div className="vacations-grid">
        {currentItems.length > 0 ? (
          currentItems.map((vacation, index) => (
            <div key={vacation._id || index} className="vacation-card">
              <div className="vacation-image">
                <img
                  src={vacation.image}
                  alt={vacation.name}
                  onError={(e) => {
                    e.target.src = '/assets/images/placeholder.png';
                  }}
                />
              </div>
              <div className="vacation-info">
                <h3>{vacation.name}</h3>
                <p className="vacation-description">{vacation.introduction}</p>
                <div className="vacation-actions">
                  <button
                    className="btn btn-primary edit-btn"
                    onClick={() => {
                      setSelectedVacationBeingHere(vacation);
                      handleEditModalShow();
                    }}
                    title="Edit Vacation"
                  >
                    <i className="bx bx-edit"></i>
                    Edit
                  </button>
                  <button
                    className="btn btn-danger delete-btn"
                    onClick={() => handleDeleteVacationBeingHere(vacation)}
                    title="Delete Vacation"
                  >
                    <i className="bx bx-trash"></i>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-data">
            <div className="no-data-content">
              <i className="bx bx-map-x"></i>
              <p>No vacation being here found</p>
              <small>Try adjusting your search criteria</small>
            </div>
          </div>
        )}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-left"></i>
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => paginate(i + 1)}
              className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            <i className="bx bx-chevron-right"></i>
          </button>
        </div>
      )}

      {/* Create Vacation Modal */}
      <Modal
        show={createVacationBeingHereModelShow}
        onHide={handleCreateModalClose}
        className="vacation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Vacation Being Here</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateVacationBeingHere
            onSuccess={(res) => {
              console.log(res);
              setCreateVacationBeingHereModelShow(false);
              setVacationBeingHereList(res?.vacationBeingHeres || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCreateModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Vacation Modal */}
      <Modal
        show={editVacationBeingHereModelShow}
        onHide={handleEditModalClose}
        className="vacation-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Vacation Being Here</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditVacationBeingHere
            vacationBeingHere={selectedVacationBeingHere}
            onSuccess={(res) => {
              setEditVacationBeingHereModelShow(false);
              setVacationBeingHereList(res?.vacationBeingHeres || res);
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleEditModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ViewVacationBeingHere;
